(function($) {
  'use strict';

  const newsletterKey = 'Loomis_Newsletter';

  let trigger = $(".js-newsletter-trigger"),
      mobileTrigger = $(".js-newsletter-trigger-mobile"),
      target = $(".js-newsletter-target"),
      cancel = $(".js-newsletter-cancel");


  // Toggle
  // ==============================================
  function newsletterToggle() {

    if ( target.hasClass('open') ) {
      target.removeClass('open');
      trigger.attr('aria-expanded', 'false').html('<p class="d-flex">Newsletter <img src="/themes/custom/loomis/dist/images/icon-arrow-white-right.svg" alt=""></p>');
    } else {
      target.addClass('open');
      trigger.attr('aria-expanded', 'true').html('<p class="d-flex">Close <img src="/themes/custom/loomis/dist/images/icon-arrow-white-right.svg" alt=""></p>');
    }
  }

  trigger.on('click', newsletterToggle);
  mobileTrigger.on('click', newsletterToggle);

  // Cancel button
  // don't use variables because ajax
  // ==============================================
  function newsletterClose() {
    $(".js-newsletter-target").removeClass('open');
    $(".js-newsletter-trigger").attr('aria-expanded', 'false').html('<p class="d-flex">Newsletter <img src="/themes/custom/loomis/dist/images/icon-arrow-white-right.svg" alt=""></p>');
  }

  $(".js-newsletter-cancel").on('click', function(e) {
    e.preventDefault();
    newsletterClose();
  });

  $(document).ajaxComplete(function(event, xhr, settings) {

    // Check for successful form submission
    if ($('#newsletter-toggle').find('.webform-confirmation__message').length) {
      // Open newsletter window
      target.addClass('open');
      trigger.attr('aria-expanded', 'true').html('<p class="d-flex">Close <img src="/themes/custom/loomis/dist/images/icon-arrow-white-right.svg" alt=""></p>');
    }

    $(".js-newsletter-cancel").on('click', function(e) {
      e.preventDefault();
      newsletterClose();
    });
  });


  // Document click
  // ==============================================
  function newsletterCloseWindow(e) {
    if (
      !cancel.is(e.target) &&
      !target.is(e.target) &&
      !target.find("*").is(e.target) &&
      !trigger.is(e.target) &&
      !trigger.find("*").is(e.target)
    ) {
      newsletterClose();
    }
  }

  $(document).on('mouseup keyup', newsletterCloseWindow);



  // Open & close on load
  // ==============================================
  const killTimeout = setTimeout(function() {
    target.removeClass('open');
    trigger.attr('aria-expanded', 'false').html('<p class="d-flex">Newsletter <img src="/themes/custom/loomis/dist/images/icon-arrow-white-right.svg" alt=""></p>');
  }, 4200);

  function newsletterLoaded() {
    if (window.sessionStorage.getItem(newsletterKey) === null) {
      setTimeout(function () {
        target.addClass('open');
        trigger.attr('aria-expanded', 'true').html('<p class="d-flex">Close <img src="/themes/custom/loomis/dist/images/icon-arrow-white-right.svg" alt=""></p>');
        window.sessionStorage.setItem(newsletterKey, 'true');
      }, 1200);
    }
  }

  function newsletterKilltimeout() {
    clearInterval(killTimeout);
  }

  let windowWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
  if (windowWidth >= 768) {
    $(window).on('load', newsletterLoaded);
  }
  target.on('mouseover', newsletterKilltimeout);

})(jQuery);
